import React, { useEffect, useState } from 'react';
import useFetch from '../../../../components/hooks/useFetch';
import Input from '../../../../components/form/Input';
import { format } from 'date-fns';
import { CARREGA_SISTEMAS_CONTRATOS } from '../../../../services/delegacaoAcesso';

function FormVisualizar({ acaoCancelar, permissionarioSelecionado }) {
  const { request: requestPermissionario, data: dadosPermissionario } =
    useFetch();
  const [loading, setLoading] = useState(true);

  const cancelar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };

  useEffect(() => {
    if (permissionarioSelecionado) {
      requestPermissionario(
        CARREGA_SISTEMAS_CONTRATOS(
          permissionarioSelecionado.idCorreios,
          permissionarioSelecionado.idCorreiosPF,
        ),
      );
    }
  }, [permissionarioSelecionado]);

  useEffect(() => {
    if (dadosPermissionario) {
      setLoading(false);
    }
  }, [dadosPermissionario]);

  const [acesso, setAcesso] = React.useState('1');

  const handleAcesso = (event) => {
    setAcesso(event.target.value);
  };

  return (
    <>
      <div className="dialog-main">
        <div className="radio-container bg-superficie-var">
          <label className="radio">
            <Input
              type="radio"
              id="contratos"
              name="acessos"
              value="1"
              checked={acesso === '1'}
              onChange={handleAcesso}
            />

            <div className="subtitulo">
              <span>Contratos</span>
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="sistemas"
              name="acessos"
              value="0"
              checked={acesso === '0'}
              onChange={handleAcesso}
            />

            <div className="subtitulo">
              <span>Sistemas</span>
            </div>
          </label>
        </div>
      </div>
      {loading}
      <div className="dialog-main">
        {acesso === '1' ? (
          <div className="visualizar-contratos">
            {dadosPermissionario?.listaPermissaoContratoResponse ? (
              <>
                {dadosPermissionario?.listaPermissaoContratoResponse?.map(
                  (contrato) => (
                    <div className="contrato" key={contrato.nuContrato}>
                      <div className="info-contrato">
                        <h6>Contrato nº {contrato.nuContrato}</h6>
                        <small>
                          <b>Categoria:</b> {contrato.contrato.categoria}
                          <b> Vigência:</b>
                          {format(
                            new Date(contrato.contrato.dtInicioVigencia),
                            'dd/MM/yyyy',
                          )}{' '}
                          -
                          {format(
                            new Date(contrato.contrato.dtFimVigencia),
                            'dd/MM/yyyy',
                          )}
                        </small>
                      </div>

                      {contrato.listaPermissaoCentroCustoResponse?.map(
                        (centroCusto) => (
                          <>
                            <hr></hr>
                            <div
                              className="centro-custo bg-superficie-var"
                              key={centroCusto.nuCentroCusto}
                            >
                              <p className="subtitulo-base nome-centro">
                                Centro de custo: {centroCusto.nuCentroCusto}
                              </p>
                              {centroCusto.listaPermissaoCartaoPostagemResponse?.map(
                                (cartao) => (
                                  <>
                                    <div
                                      className="cartao-postagem"
                                      key={cartao.nuCartaoPostagem}
                                    >
                                      <small className="cartao pequeno">
                                        {cartao.nuCartaoPostagem} -{' '}
                                      </small>
                                      <small className="status-cartao legenda ativo">
                                        {cartao.status}
                                      </small>
                                    </div>
                                  </>
                                ),
                              )}
                            </div>
                          </>
                        ),
                      )}
                    </div>
                  ),
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <div>Carregando...</div>
                ) : (
                  <h6>Não foram encontrados Contratos associados.</h6>
                )}
              </>
            )}
          </div>
        ) : (
          <div className="visualizar-sistemas">
            {dadosPermissionario?.listaPermissaoSistemaResponse ? (
              <>
                {dadosPermissionario?.listaPermissaoSistemaResponse?.map(
                  (item) => (
                    <div className="sistema" key={item.idSistema}>
                      <h6>{item.nome} </h6>
                      <ul>
                        {item.listaPermissaoGrupoResponse?.map((item) => (
                          <li key={item.idGrupo}>{item.nome}</li>
                        ))}
                      </ul>
                    </div>
                  ),
                )}
              </>
            ) : (
              <>
                {loading ? (
                  <div>Carregando...</div>
                ) : (
                  <h6>Não foram encontrados Sistemas associados.</h6>
                )}
              </>
            )}
          </div>
        )}
      </div>

      <div className="dialog-footer btns-row-fixo">
        <button className="btn-pre btn-fecha-dialog" onClick={cancelar}>
          Fechar
        </button>
      </div>
    </>
  );
}
export default FormVisualizar;
